import { Grid } from '@mui/material';
import { FilterSvg } from '@/icons';

export const FilterBtn = ({ onClick, children, startIcon, isFilterDrawerOpen, disable = false, dataId = '' }: any) => {
  return (
    <Grid
      onClick={onClick}
      style={{
        pointerEvents: disable ? 'none' : 'all',
        display: 'flex',
        width: '52px',
        height: '52px',
        padding: '12px',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '4px',
        borderRadius: '9px',
        border: '1px solid var(--stroke, #E2E8F0)',
        background: isFilterDrawerOpen ? '#F1F2F4' : '#FFF',
        boxShadow: '2px 4px 10px 0px rgba(180, 191, 205, 0.20)',
        cursor: 'pointer'
      }}
      data-testid={dataId}
      className='filter-btn'
    >
      <FilterSvg />
    </Grid>
  );
};

export default FilterBtn;
